export default "__VITE_ASSET__BtXJLjZH__"